import styled from 'styled-components';
import PromocodeSVG from './promo-code.svg';

const Promocode = styled(
  PromocodeSVG as React.SFC<React.SVGProps<SVGSVGElement>>,
)`
  width: ${props => props.width || '2.4rem'};
  height: ${props => props.height || '2.4rem'};
  fill: ${props => props.fill || props.theme.colors.goBrandBlue.base};
  padding: ${props => props.padding || "0"}
`;

export default Promocode;